import React from 'react';
import { Slider, Rail, Tracks, Handles, } from 'react-compound-slider';
import { makeStyles } from '../styles';
import { Handle } from './Handle';
import { Track } from './Track';
const useStyles = makeStyles(({ palette, spacing }) => ({
    rail: {
        position: 'absolute',
        width: '100%',
        height: 5,
        borderRadius: spacing(0.25),
        cursor: 'pointer',
        backgroundColor: palette.grey.tint,
    },
}));
const defaultSliderStyle = {
    position: 'relative',
    width: '100%',
    height: 16,
    paddingTop: 6,
};
function HistogramRangeSlider({ children, domain = [0, 1], onChange, mode = 1, rangeValues, rootStyle = defaultSliderStyle, step = 0.001, }) {
    const classes = useStyles();
    return (React.createElement(Slider, { mode: mode, step: step, domain: domain, rootStyle: rootStyle, onChange: onChange, values: rangeValues },
        React.createElement(Rail, null, ({ getRailProps }) => (React.createElement("div", { className: classes.rail, ...getRailProps() }))),
        React.createElement(Handles, null, ({ handles, getHandleProps, ...rest }) => children ? (
        // @ts-ignore
        children({ handles, getHandleProps, ...rest })) : (React.createElement(React.Fragment, null, handles.map(handle => (React.createElement(Handle, { key: handle.id, handle: handle, domain: domain, getHandleProps: getHandleProps })))))),
        React.createElement(Tracks, { left: false, right: false }, ({ tracks, getTrackProps }) => (
        // Do we need this div?
        React.createElement(React.Fragment, null, tracks.map(({ id, source, target }) => (React.createElement(Track, { key: id, source: source, target: target, getTrackProps: getTrackProps }))))))));
}
export default HistogramRangeSlider;
//# sourceMappingURL=RangeSlider.js.map